const programs = {
  credito: 'Credit card',
  debito: 'Banking',
  'debito zero-balance': 'Banking',
  'credito zero-balance': 'Credit',
};

export default programs;
